import api from "../../../../services/api";

export const getUserList = async (params = {}) => {
  // MOCK: Using JSON file for development
  // Remove this section when endpoint is ready
  // try {
  //   const response = await fetch("/mock-users-list.json");
  //   const data = await response.json();
  //   return data;
  // } catch (error) {
  //   console.error("Error fetching mock data:", error);
  //   throw error;
  // }

  
  const orderByMap = {
    createdAt: "createdAt",
    fullName: "fullName",
    updatedAt: "updatedAt",
    created_at: "createdAt",
    full_name: "fullName",
    updated_at: "updatedAt",
    email: "email",
    status: "status",
  };

  const orderBy = params.order_by || "created_at";
  const mappedOrderBy = orderByMap[orderBy] || orderBy;

  const body = {
    page: params.page || 1,
    page_size: params.page_size || 20,
    order_by: mappedOrderBy,
    order_direction: params.order_direction || "DESC",
    include_deleted: params.include_deleted || false,
  };

  // Add search if provided
  // Support both string and object format: "keyword" or { keyword: "keyword" }
  if (params.search) {
    if (typeof params.search === 'string' && params.search.trim() !== "") {
      body.search = {
        keyword: params.search.trim(),
      };
    } else if (params.search.keyword && typeof params.search.keyword === 'string' && params.search.keyword.trim() !== "") {
      body.search = {
        keyword: params.search.keyword.trim(),
      };
    }
  }

  // Add filters if provided
  const filters = {};
  if (params.statuses && params.statuses.length > 0) {
    filters.status = params.statuses;
  }
  if (params.roleUuids && params.roleUuids.length > 0) {
    filters.roleUuids = params.roleUuids;
  }
  if (params.groupUuids && params.groupUuids.length > 0) {
    filters.groupUuids = params.groupUuids;
  }

  // Only add filters object if it has at least one filter
  if (Object.keys(filters).length > 0) {
    body.filters = filters;
  }

  const response = await api.post("/v1/user/list", body);
  return response.data;
};

export const getRoleList = async (params = {}) => {
  // MOCK: Using JSON file for development
  // Remove this section when endpoint is ready
//   try {
//     const response = await fetch("/mock-roles-list.json");
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching mock roles data:", error);
//     throw error;
//   }

  // API CALL: Uncomment when endpoint is ready
  const body = {
    user_uuid: params.user_uuid || null,
    page: params.page || 1,
    page_size: params.page_size || 20,
    order_by: params.order_by || ["created_at"],
    order_direction: params.order_direction || ["DESC"],
    search: params.search || null,
  };
  const response = await api.post("/v1/role/list", body);
  return response.data;
};

export const getRoleListWithFilters = async (params = {}) => {
  // API CALL: Uncomment when endpoint is ready
  const body = {
    page: params.page || 1,
    page_size: params.page_size || 20,
    order_by: params.order_by || ["roleName"],
    order_direction: params.order_direction || ["DESC"],
    search: params.search || null,
  };
  const response = await api.post("/v1/user/role/list_filter", body);
  return response.data;
};

export const getRoleByUuid = async (roleUuid) => {
  if (!roleUuid) {
    throw new Error("roleUuid is required");
  }

  try {
    const response = await api.get(`/v1/role/${roleUuid}`);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    // Handle both snake_case and camelCase formats
    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || null;

    // Success (2xx)
    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode
      };
    }

    // Error - extract message from msgCode
    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while fetching role.')
      : 'An error occurred while fetching role.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const errorMessage = responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const getUserByUuid = async (userUuid) => {
  if (!userUuid) {
    throw new Error("userUuid is required");
  }

  // try {
  //   const mockData = {
  //     full_name: "John Doe",
  //     user_type: "standard",
  //     created_by_name: "Admin User",
  //     created_by_user_uuid: "99999999-1111-2222-3333-444444444444",
  //     email: "david.ramirez@dealerlakes.com",
  //     state: "ACTIVE",
  //     created_at: "2025-01-10T12:34:56Z",
  //     last_login: "2025-02-02T09:30:00Z",
  //     total_logins: 15,
  //     deactivated_date: null
  //   };

  //   return {
  //     body: mockData,
  //     status_code: 200,
  //     meta: null
  //   };
  // } catch (error) {
  //   console.error("Error fetching mock user data:", error);
  //   throw error;
  // }

  // API CALL: Uncomment when endpoint is ready
  try {
    const response = await api.get(`/v1/user/${userUuid}`);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || null;

    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode,
        meta: responseData.meta || null
      };
    }

    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while fetching user.')
      : 'An error occurred while fetching user.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const errorMessage = responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const updateRoleByUuid = async (roleUuid, roleData) => {
  if (!roleUuid) {
    throw new Error("roleUuid is required");
  }

  try {
    const body = {
      uuid: roleData.uuid,
      name: roleData.name,
      description: roleData.description || "",
      metadata: roleData.metadata || {},
      updated_by_id: roleData.updated_by_id || 0,
    };

    const response = await api.post(`/v1/role/${roleUuid}`, body);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    // Handle both snake_case and camelCase formats
    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || null;

    // Success (2xx)
    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode
      };
    }

    // Error - extract message from msgCode
    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while updating role.')
      : 'An error occurred while updating role.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const errorMessage = responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const assignRole = async (userUuids, roleUuids) => {
  if (!userUuids || userUuids.length === 0) {
    throw new Error("At least one user UUID is required");
  }

  if (!roleUuids || roleUuids.length === 0) {
    throw new Error("At least one role UUID is required");
  }

  try {
    const body = {
      user_uuids: userUuids,
      role_uuids: roleUuids,
    };

    const response = await api.post("/v1/role/assign", body);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    // Handle both snake_case and camelCase formats
    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || null;

    // Success (2xx)
    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode
      };
    }

    // Error - extract message from msgCode
    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while assigning role.')
      : 'An error occurred while assigning role.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const errorMessage = responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const createRole = async (roleData) => {
  if (!roleData || !roleData.name) {
    throw new Error("Role name is required");
  }

  try {
    const body = {
      code: roleData.code || "",
      name: roleData.name,
      description: roleData.description || "",
      metadata: roleData.metadata || {},
    };

    const response = await api.post("/v1/role/create", body);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    // Handle both snake_case and camelCase formats
    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || null;

    // Success (2xx)
    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode
      };
    }

    // Error - extract message from msgCode
    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while creating role.')
      : 'An error occurred while creating role.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const errorMessage = responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const getGroupList = async (params = {}) => {
  try {
    const body = {
      ...(params.user_uuid && { user_uuid: params.user_uuid }),
      page: params.page ?? 1,
      page_size: params.page_size ?? 8,
      // order_by: params.order_by ?? ["created_at"],
      // order_direction: params.order_direction ?? ["DESC"],
      // ...(params.search && params.search.keyword && { search: params.search }),
    };

    const response = await api.post("/v1/group/list", body);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    // Handle both snake_case and camelCase formats
    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || [];
    const meta = responseData.meta || {};

    // Success (2xx)
    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: Array.isArray(responseBody) ? responseBody : [],
        meta: meta
      };
    }

    // Error - extract message from msgCode
    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while listing groups.')
      : 'An error occurred while listing groups.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const errorMessage = responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const assignGroups = async (userUuids, groupUuids) => {
  if (!userUuids || userUuids.length === 0) {
    throw new Error("At least one user UUID is required");
  }

  if (!groupUuids || groupUuids.length === 0) {
    throw new Error("At least one group UUID is required");
  }

  try {
    const body = {
      user_uuids: userUuids,
      group_uuids: groupUuids,
    };

    const response = await api.post("/v1/group/assign", body);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    // Handle both snake_case and camelCase formats
    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || null;

    // Success (2xx)
    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode
      };
    }

    // Error - extract message from msgCode
    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while assigning group.')
      : 'An error occurred while assigning group.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const errorMessage = responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const enrollment = async (enrollmentData) => {
  if (!enrollmentData || !enrollmentData.emails || !Array.isArray(enrollmentData.emails) || enrollmentData.emails.length === 0) {
    throw new Error("At least one email is required");
  }

  try {
    const body = {
      emails: enrollmentData.emails,
      user_type: enrollmentData.user_type || "STANDARD",
      roles: enrollmentData.roles || [],
      groups: enrollmentData.groups || [],
      send_invitation:
        typeof enrollmentData.send_invitation === "boolean"
          ? enrollmentData.send_invitation
          : true,
    };

    const response = await api.post("/v1/user/enrollment", body);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    // Handle both snake_case and camelCase formats
    const statusCode = responseData.status_code || responseData.statusCode || response?.status || 200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body || null;

    // Success (2xx)
    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode
      };
    }

    // Error - extract message from msgCode
    const errorMessage = msgCode.length > 0 
      ? (msgCode[0].description || msgCode[0].code || 'An error occurred while enrolling users.')
      : 'An error occurred while enrolling users.';

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;

  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const msgCode = responseData.msg_code || responseData.msgCode || [];
      const fromMsgCode =
        Array.isArray(msgCode) && msgCode.length > 0
          ? msgCode[0].description || msgCode[0].code
          : null;
      const errorMessage =
        fromMsgCode ||
        responseData.message ||
        (error.response.status === 500
          ? "Server error while enrolling users. Try again or contact support."
          : error.message);

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

/**
 * Resend invitation for a user with membership pending invitation (IN_PROGRESS).
 * POST /v1/user/enrollment/send-invitation — body: { email }
 */
export const sendEnrollmentInvitation = async (email) => {
  if (!email || typeof email !== "string" || !email.trim()) {
    throw new Error("email is required");
  }

  try {
    const response = await api.post("/v1/user/enrollment/send-invitation", {
      email: email.trim(),
    });
    const responseData = response.data;

    if (!responseData) {
      throw new Error("Invalid response from server");
    }

    const statusCode =
      responseData.status_code ||
      responseData.statusCode ||
      response?.status ||
      200;
    const msgCode = responseData.msg_code || responseData.msgCode || [];
    const responseBody = responseData.body ?? null;

    if (statusCode >= 200 && statusCode < 300) {
      return {
        body: responseBody,
        status_code: statusCode,
      };
    }

    const errorMessage =
      msgCode.length > 0
        ? msgCode[0].description ||
          msgCode[0].code ||
          "Could not send invitation."
        : "Could not send invitation.";

    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: statusCode,
    };
    throw error;
  } catch (error) {
    if (error.response && error.response.data) {
      const responseData = error.response.data;
      const msgCode = responseData.msg_code || responseData.msgCode || [];
      const fromMsgCode =
        Array.isArray(msgCode) && msgCode.length > 0
          ? msgCode[0].description || msgCode[0].code
          : null;
      const errorMessage =
        fromMsgCode || responseData.message || error.message;

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status,
      };
      throw apiError;
    }

    throw error;
  }
};

export const getUserStatusList = async (params = {}) => {
  // MOCK: Using JSON file for development
  // Remove this section when endpoint is ready
  try {
    const response = await fetch("/mock-status-list.json");
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching mock status data:", error);
    throw error;
  }

  // API CALL: Uncomment when endpoint is ready
  // const body = {
  //   page: params.page || 1,
  //   page_size: params.page_size || 20,
  //   order_by: params.order_by || ["status"],
  //   order_direction: params.order_direction || ["ASC"],
  //   search: params.search || null,
  // };
  // const response = await api.post("/v1/user/status/list_filter", body);
  // return response.data;
};

export const deactivateUser = async (userUuidOrUuids) => {
  // Validate input before processing
  if (!userUuidOrUuids || (Array.isArray(userUuidOrUuids) && userUuidOrUuids.length === 0)) {
    throw new Error("At least one user UUID is required");
  }

  // Support both single userUuid and array of userUuids
  const userUuids = Array.isArray(userUuidOrUuids) ? userUuidOrUuids : [userUuidOrUuids];

  // If multiple users, use Promise.all to deactivate them in parallel
  if (userUuids.length > 1) {
    try {
      const promises = userUuids.map(userUuid => {
        const body = {
          user_uuid: userUuid,
          tenants_uuid: []
        };

        return api.post("/v1/user/deactivate", body);
      });

      const responses = await Promise.all(promises);
      const results = responses.map(response => {
        const responseData = response.data;

        // Check if the statusCode in the response body indicates an error
        if (responseData.statusCode && responseData.statusCode !== 200) {
          // Extract error message from msgCode
          let errorMessage = 'Failed to deactivate user';

          if (responseData.msgCode && Array.isArray(responseData.msgCode) && responseData.msgCode.length > 0) {
            errorMessage = responseData.msgCode[0].description || responseData.msgCode[0].code || errorMessage;
          } else if (responseData.message) {
            errorMessage = responseData.message;
          }

          // Create an error with the structure the component expects
          const error = new Error(errorMessage);
          error.response = {
            data: responseData,
            status: responseData.statusCode,
          };
          throw error;
        }

        return responseData;
      });

      // Return array of results for multiple users
      return results;
    } catch (error) {
      // If any request fails, throw the error
      throw error;
    }
  }

  // Single user deactivation (original behavior)
  const body = {
    user_uuid: userUuids[0],
    tenants_uuid: []
  };

  const response = await api.post("/v1/user/deactivate", body);
  const responseData = response.data;

  // Check if the statusCode in the response body indicates an error
  // Even if the HTTP response is 200, the body may contain statusCode 500, 400, etc.
  if (responseData.statusCode && responseData.statusCode !== 200) {
    // Extract error message from msgCode
    let errorMessage = 'Failed to deactivate user';

    if (responseData.msgCode && Array.isArray(responseData.msgCode) && responseData.msgCode.length > 0) {
      errorMessage = responseData.msgCode[0].description || responseData.msgCode[0].code || errorMessage;
    } else if (responseData.message) {
      errorMessage = responseData.message;
    }

    // Create an error with the structure the component expects
    const error = new Error(errorMessage);
    error.response = {
      data: responseData,
      status: responseData.statusCode,
    };
    throw error;
  }

  return responseData;
};

export const resetPassword = async (email) => {
  if (!email) {
    throw new Error("Email is required");
  }

  try {
    const body = {
      email: email
    };

    const response = await api.post("/v1/user/reset-password", body);
    const responseData = response.data;

    if (!responseData) {
      throw new Error('Invalid response from server');
    }

    const statusCode = responseData.statusCode || response?.status || 200;
    if (statusCode < 200 || statusCode >= 300) {
      let errorMessage = 'Failed to reset password';

      if (responseData.msgCode && Array.isArray(responseData.msgCode) && responseData.msgCode.length > 0) {
        errorMessage = responseData.msgCode[0].description || responseData.msgCode[0].code || errorMessage;
      } else if (responseData.message) {
        errorMessage = responseData.message;
      }

      const error = new Error(errorMessage);
      error.response = {
        data: responseData,
        status: statusCode,
      };
      throw error;
    }

    return responseData;
  } catch (error) {
    if (error.response && error.response.data && error.response.status) {
      throw error;
    }

    if (error.response && error.response.data) {
      const responseData = error.response.data;
      let errorMessage = 'Failed to reset password';

      if (responseData.msgCode && Array.isArray(responseData.msgCode) && responseData.msgCode.length > 0) {
        errorMessage = responseData.msgCode[0].description || responseData.msgCode[0].code || errorMessage;
      } else if (responseData.message) {
        errorMessage = responseData.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      const apiError = new Error(errorMessage);
      apiError.response = {
        data: responseData,
        status: error.response.status || responseData.statusCode,
      };
      throw apiError;
    }

    throw error;
  }
};

